import type { ReactNode } from "react";
import { BrowserSessionProvider } from "@softmax/web-features/session";
import { BrowserDataProvider } from "@softmax/web-features/data";
import { ResetSessionContext } from "./use-reset-session";
import { useProductSession } from "./use-product-session";

export function ProductSession({ children }: { readonly children: ReactNode }) {
  return (
    <BrowserSessionProvider>
      <SessionScope>{children}</SessionScope>
    </BrowserSessionProvider>
  );
}

function SessionScope({ children }: { readonly children: ReactNode }) {
  const { session, client, viewer, updating, rechecking, resetSession } =
    useProductSession();

  if (updating) return <output>Updating your account…</output>;

  if (rechecking)
    return (
      <div role={session.kind === "unavailable" ? "alert" : "status"}>
        Checking your account…
        {session.kind === "unavailable" && (
          <button onClick={() => void session.refresh()}>Try again</button>
        )}
      </div>
    );

  return (
    <ResetSessionContext value={resetSession}>
      <BrowserDataProvider
        queryClient={client}
        viewerId={
          session.session?.user.id ?? viewer.data?.subject_id ?? "anonymous"
        }
        onAuthorizationError={() => void session.refresh()}
      >
        {children}
      </BrowserDataProvider>
    </ResetSessionContext>
  );
}
